export const MEDIA_KEY_ERROR_NAME = 'MediaKeyError';

/**
 * Thrown when the asset download endpoint answers with a message meant for the
 * user (e.g. an expired loan) instead of a media key.
 * The message is already localised by the backend, so it can be displayed as is.
 */
export class MediaKeyError extends Error {
  constructor(message) {
    super(message);
    this.name = MEDIA_KEY_ERROR_NAME;
  }
}

export const isMediaKeyError = (error) => error?.name === MEDIA_KEY_ERROR_NAME;

/**
 * The download endpoint puts the user facing message in the `error` field of the
 * payload, both on success and on failure (e.g. a 400 with an empty key).
 */
export const extractMediaKeyErrorMessage = (data) => {
  const message = data?.error;
  return typeof message === 'string' && message.trim() ? message : null;
};
